
import WebService from "../WebService"
const Lagacy = {
    get_orders(params) {
        return WebService.get("/lagacy/orders?" + params)
    }
}
export default Lagacy